/**
 * Clive: keep the PDP Route cash back figure in step with the variant picker.
 *
 * Live never did this — `data-add-to-cart-reward` exists in
 * ../clive-theme/sections/main-product.liquid but no JS reads it, so live only
 * refreshes the amount on a full page load with ?variant=. See docs/migration.md § P10.
 *
 * Stiletto's own price swap does not touch this node, so it needs its own listener.
 * `product:variant-change` is dispatched by theme.js only when
 * window.flu.states.useCustomEvents is true — snippets/theme-globals.liquid sets it.
 */
(function () {
  function update(container, variant) {
    if (!container || !variant) return;

    // The line and the hidden modal source (cloned by theme.js on open) both carry one.
    var amounts = container.querySelectorAll('[data-clive-rewards-amount]');
    if (!amounts.length) return;

    var source = container.querySelector('[data-clive-rewards-variant="' + variant.id + '"]');
    if (source) {
      // Pre-rendered by Liquid, so it carries the shop's real money format.
      for (var i = 0; i < amounts.length; i++) {
        amounts[i].textContent = source.innerHTML.trim();
      }
      container.hidden = false;
      return;
    }

    // A variant with no pre-rendered node is one Liquid deliberately skipped
    // (custom.hidden). Leave the last good figure rather than showing a wrong one.
  }

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    // theme.js dispatches on `document` with no section scope (assets/theme.js:3855),
    // so every rewards block on the page is offered the variant. Ownership is decided
    // by whether a block pre-rendered an amount for that variant id — one belonging to
    // another product (quick view, featured product) has none and is left untouched.
    var containers = document.querySelectorAll('[data-clive-rewards]');

    for (var i = 0; i < containers.length; i++) {
      update(containers[i], variant);
    }
  });
})();
